import { UseQueryResult, useQuery } from 'react-query';
import { BatchListBasic } from '@cbinsights/listservice/listservice';
import { GetListsByUser } from '.';
import { getListsByUser } from '../api/GetListsByUser';

type Params = Parameters<typeof getListsByUser>[0];
type Return = BatchListBasic;

export const useGetListsByUser = ({
  enabled = false,
  params,
}: {
  enabled: boolean;
  params: Params;
}): UseQueryResult<Return, Error> =>
  useQuery<Return, Error, Return, [GetListsByUser, Params]>(
    ['GetListsByUser', params],
    () => getListsByUser(params),
    {
      enabled,
      notifyOnChangeProps: ['data', 'isFetching'],
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
    }
  );
